import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=5e42b3f4&"
import script from "./terms-of-use.vue?vue&type=script&lang=js&"
export * from "./terms-of-use.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=5e42b3f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports